import { useEffect, useRef } from 'react';
import { api } from './api';

export interface LivePosition {
  vehicleId: number;
  t: string;
  lat: number;
  lon: number;
  speedKmh: number | null;
  course: number | null;
}

// Subscribes to /api/live. The browser reconnects by itself if the connection drops;
// `onResync` fires when we may have missed updates and should reload.
export function useLiveFeed(handlers: {
  onPosition?: (p: LivePosition) => void;
  onJourneys?: (vehicleId: number) => void;
  onResync?: () => void;
}): void {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    const source = new EventSource('/api/live');
    let wasOpen = false;
    source.addEventListener('position', (e) => ref.current.onPosition?.(JSON.parse((e as MessageEvent).data)));
    source.addEventListener('journeys', (e) => ref.current.onJourneys?.(JSON.parse((e as MessageEvent).data).vehicleId));
    source.addEventListener('resync', () => ref.current.onResync?.());
    source.onopen = () => {
      if (wasOpen) ref.current.onResync?.();
      wasOpen = true;
    };
    // The browser gives up for good when the server refuses the feed (e.g. the login ended);
    // asking for the login then sends the page to the login screen if that's why.
    source.onerror = () => {
      if (source.readyState === EventSource.CLOSED) api.me().catch(() => {});
    };
    return () => source.close();
  }, []);
}
